import { useEffect, useState } from "react";
import { LogOut, CreditCard, Bell, ShieldCheck, ChevronRight } from "lucide-react";
import { toast } from "sonner";
import api from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { Pill } from "../components/common";

export default function Profile() {
  const { user, logout } = useAuth();
  const [pkg, setPkg] = useState(null);
  const [busy, setBusy] = useState(false);
  const [notif, setNotif] = useState({ workout: true, messages: true, checkins: true });

  useEffect(() => {
    api.get("/customer/dashboard").then(({ data }) => setPkg(data.package)).catch(() => {});
  }, []);

  const subscribe = async () => {
    const pkgId = user.package_id || localStorage.getItem("im_selected_package");
    if (!pkgId) return toast.error("No plan selected. Visit pricing to choose one.");
    setBusy(true);
    try {
      const { data } = await api.post("/billing/checkout", { package_id: pkgId, origin_url: window.location.origin });
      window.location.href = data.url;
    } catch (e) {
      toast.error("Could not start checkout.");
      setBusy(false);
    }
  };

  return (
    <div className="p-5">
      <h1 className="font-heading text-4xl">Profile</h1>
      <div className="flex items-center gap-4 mt-5 card-surface rounded-xl p-4">
        <div className="w-14 h-14 rounded-full bg-brand/20 flex items-center justify-center">
          {user.picture ? <img src={user.picture} alt="" className="w-full h-full rounded-full object-cover" /> : <span className="font-heading text-2xl text-brand">{user.name[0]}</span>}
        </div>
        <div><p className="font-semibold text-lg">{user.name}</p><p className="text-secondary text-sm">{user.email}</p></div>
      </div>

      <div className="card-surface rounded-xl p-4 mt-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-2"><CreditCard className="w-5 h-5 text-brand" /><span className="font-semibold">Subscription</span></div>
          <Pill tone={user.subscription_status === "active" ? "success" : "warning"}>{user.subscription_status || "inactive"}</Pill>
        </div>
        {pkg && <p className="text-secondary text-sm mt-2">{pkg.name} · ${pkg.monthly_price}/mo</p>}
        <button data-testid="subscribe-btn" onClick={subscribe} disabled={busy}
          className="w-full mt-3 py-3 bg-brand text-white font-bold uppercase tracking-wide rounded-lg hover:bg-brand-hover transition-all disabled:opacity-60">
          {busy ? "Redirecting..." : user.subscription_status === "active" ? "Manage Billing" : "Subscribe Now"}
        </button>
      </div>

      <div className="card-surface rounded-xl p-4 mt-4">
        <div className="flex items-center gap-2 mb-3"><Bell className="w-5 h-5 text-brand" /><span className="font-semibold">Notifications</span></div>
        {[["workout", "Workout reminders"], ["messages", "Coach messages"], ["checkins", "Check-in reminders"]].map(([k, l]) => (
          <label key={k} className="flex items-center justify-between py-2 cursor-pointer">
            <span className="text-sm text-secondary">{l}</span>
            <input data-testid={`notif-${k}`} type="checkbox" checked={notif[k]} onChange={(e) => setNotif({ ...notif, [k]: e.target.checked })} className="accent-[#FF3B30] w-5 h-5" />
          </label>
        ))}
      </div>

      <div className="card-surface rounded-xl mt-4 divide-y divide-white/5">
        <div className="flex items-center gap-3 p-4"><ShieldCheck className="w-5 h-5 text-tertiary" /><span className="text-sm text-secondary flex-1">Privacy & data</span><ChevronRight className="w-4 h-4 text-tertiary" /></div>
      </div>

      <button data-testid="logout-btn" onClick={logout} className="w-full mt-4 py-3 border border-brand/40 text-brand font-semibold rounded-lg flex items-center justify-center gap-2 hover:bg-brand/10 transition-all">
        <LogOut className="w-4 h-4" /> Log Out
      </button>
    </div>
  );
}
